// extracted by mini-css-extract-plugin
export default {"container":"MessageBar_container__pc2iJ","messageBar":"MessageBar_messageBar__AELv0","muscFHIRMessageBar":"MessageBar_muscFHIRMessageBar__6KdNd"};